/*
import React, { useEffect, useState } from "react";
import { getFirestore, doc, onSnapshot } from "firebase/firestore";

const FileList = ({ selectedPatient }) => {
  const [files, setFiles] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    if (!selectedPatient) return;

    const db = getFirestore();
    const patientRef = doc(db, "registeredPatients", selectedPatient.id);

    const unsubscribe = onSnapshot(
      patientRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          setFiles(data.files || {});
        } else {
          setFiles({});
          setError("No hay archivos disponibles para esta persona.");
        }
      },
      (error) => {
        setError("Ocurrió un error al cargar los archivos.");
      }
    );

    return () => unsubscribe();
  }, [selectedPatient]);

  return (
    <div className="dataHistory">
      {error && <p style={{ color: "red" }}>{error}</p>}
      {Object.keys(files).length > 0 ? (
        <ul className="dataList">
          {Object.entries(files).map(([fileName, fileURL], index) => (
            <li className="dataItem" key={index}>
              <a href={fileURL} target="_blank" rel="noopener noreferrer">
                {fileName}
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <p>Todavía no hay archivos disponibles.</p>
      )}
    </div>
  );
};

export default FileList;
*/

/* FUNCIONANDO OK
import React, { useEffect, useState } from "react";
import { getFirestore, doc, onSnapshot } from "firebase/firestore";

const FileList = ({ selectedPatient }) => {
  const [files, setFiles] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    if (!selectedPatient) return;

    const db = getFirestore();
    const patientRef = doc(db, "registeredPatients", selectedPatient.id);

    const unsubscribe = onSnapshot(
      patientRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          setFiles(data.files || {});
        } else {
          setFiles({});
          setError("No hay archivos disponibles para esta persona.");
        }
      },
      (error) => {
        setError("Ocurrió un error al cargar los archivos.");
      }
    );

    return () => unsubscribe();
  }, [selectedPatient]);

  return (
    <div className="dataHistory">
      {error && <p style={{ color: "red" }}>{error}</p>}
      {Object.keys(files).length > 0 ? (
        <ul className="dataList">
          {Object.entries(files).map(([fileName, fileData], index) => (
            <li className="dataItem" key={index}>
              <a href={fileData.url} target="_blank" rel="noopener noreferrer">
                {fileData.originalName}
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <p>Todavía no hay archivos disponibles.</p>
      )}
    </div>
  );
};

export default FileList;
*/

// COMPONENTE - FileList.js

// ESTO FUNCIONA PERFECTO
/*
import React from "react";
import { auth } from "../../shared/firebase/firebase";
import { toast } from "react-toastify";

const FileList = ({ files }) => {
  const handleDownload = async (filePath) => {
    try {
      const token = await auth.currentUser.getIdToken();

      const response = await fetch(
        "https://downloadpatientfile-gdgxgwdpxq-uc.a.run.app",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ path: filePath }),
        },
      );

      if (!response.ok) {
        throw new Error("Error al descargar archivo");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filePath.split("/").pop();
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("handleDownload", error);
      toast.error("No se pudo descargar el archivo.");
    }
  };

  return (
    <div>
      {files.map((file) => (
        <div
          key={file.path}
          style={{
            marginBottom: "10px",
            backgroundColor: "#f5f5f5",
            padding: "10px",
            borderRadius: "5px",
          }}
        >
          <button
            style={{
              width: "100%",
              border: "none",
              background: "none",
              textAlign: "left",
              cursor: "pointer",
              color: "#007bff",
              fontWeight: "bold",
            }}
            onClick={() => handleDownload(file.path)}
          >
            {file.label}
          </button>
        </div>
      ))}
    </div>
  );
};

export default FileList;
*/

import React from "react";
import { auth } from "../../shared/firebase/firebase";
import { toast } from "react-toastify";

const FileList = ({ files }) => {
  const handleDownload = async (filePath) => {
    try {
      const token = await auth.currentUser.getIdToken();

      const response = await fetch(
        "https://downloadpatientfile-gdgxgwdpxq-uc.a.run.app",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ path: filePath }),
        },
      );

      if (!response.ok) {
        throw new Error("Error al descargar archivo");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filePath.split("/").pop();
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("handleDownload", error);
      toast.error("No se pudo descargar el archivo.");
    }
  };

  return (
    <div className="dataHistory">
      {files && files.length > 0 ? (
        <ul className="dataList">
          {files.map((file) => (
            <li key={file.path} className="dataItem">
              <button
                type="button"
                onClick={() => handleDownload(file.path)}
                style={{
                  width: "100%",
                  border: "none",
                  background: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  color: "inherit",
                  font: "inherit",
                  padding: 0,
                }}
              >
                {file.label}
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p>Todavía no hay archivos registrados.</p>
      )}
    </div>
  );
};

export default FileList;
